import type { FeedListItem } from "../../../shared/contracts/product-pages.js";
import type { RoundFeedCard } from "../../../shared/contracts/round-feed.js";
import { RoundPoster } from "./round-poster.js";
import { RematchButton } from "../rounds/rematch-button.js";
import { RoundPosterShare } from "../../share/round-poster-share.js";
import { FeedSocial } from "./feed-social.js";

export function RoundPosterTile(props: {
  card: RoundFeedCard;
  event: FeedListItem;
  onOpen(): void;
  social?: boolean;
  actions?: boolean;
}) {
  return (
    <article className="fr-round-tile">
      <RoundPoster card={props.card} onOpen={props.onOpen} />
      {props.actions !== false && !props.card.underReview && (
        <div className="fr-round-actions">
          {props.card.canRematch && (
            <RematchButton roundId={props.card.roundId} compact />
          )}
          <RoundPosterShare roundId={props.card.roundId} />
        </div>
      )}
      {props.social && (
        <details className="fr-round-discussion">
          <summary>Reactions & comments</summary>
          <FeedSocial event={props.event} />
        </details>
      )}
    </article>
  );
}
